module.exports = function() {
  return new Worker(__webpack_public_path__ + "4d5e7252c639878fefa6.worker.js");
};